import { useMemo } from 'react';
import { buildReactFlowElements, type LayoutResult } from './layout-flowchart';
import { parseMermaidFlowchart } from './parse-mermaid-flowchart';

export function useFlowchartLayout(content: string): LayoutResult | null {
  return useMemo(() => {
    const parsed = parseMermaidFlowchart(content);
    if (!parsed) {
      return null;
    }

    return buildReactFlowElements(parsed);
  }, [content]);
}
